import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const STRINGS = {
  en: {
    "nav.services": "Services",
    "nav.howItWorks": "How It Works",
    "nav.schedule": "Schedule",
    "nav.reviews": "Reviews",
    "nav.location": "Location",
    "nav.faq": "FAQ",
    "nav.blog": "Blog",
    "cta.schedulePickup": "Schedule Pickup",
    "cta.schedulePickupFree": "Schedule a Free Pickup",
    "cta.tenOff": "$10 off",
    "cta.payOnline": "Pay Online",
    "cta.claimTenVoucher": "Claim my $10 voucher",
    "cta.exploreServices": "Explore Services",
    "cta.howItWorks": "How it works",
    "cta.call": "Call",
    "cta.scheduleShort": "Schedule",

    "hero.badge": "Proudly Veteran & Family-Owned",
    "hero.title1": "East Valley's most-loved",
    "hero.title2": "dry cleaning & laundry,",
    "hero.title3": "delivered with care.",
    "hero.subtitle":
      "Trusted at the same Chandler location since 1993 — over 30 years of expert garment care, now under proud new ownership. We pick up, clean, press, and deliver to your doorstep — free across the East Valley.",
    "hero.rating": "4.9 / 5",
    "hero.reviewsCount": "· 480+ local reviews",
    "hero.freePickup": "Free pickup & delivery",
    "hero.eco": "Eco-friendly cleaning",
    "hero.nowServing": "Now serving",
    "hero.eastValley": "The East Valley",
    "hero.nextPickup": "Next available pickup",
    "hero.nextPickupTime": "Tomorrow · 8:00 AM – 11:00 AM window",
    "hero.reserveSpot": "Reserve My Spot",

    "voucher.tag": "New customer welcome pack",
    "voucher.title1": "Get",
    "voucher.title2": "$10 off",
    "voucher.title3": "your first pickup.",
    "voucher.body":
      "We'd love to welcome you to the Oxford family. Claim your $10 voucher in seconds — show your code at your first pickup and we'll take it off the top. No catch, no minimum.",
    "voucher.instantCode": "Instant code",
    "voucher.noCard": "No credit card",
    "voucher.firstTime": "First-time customers",
    "voucher.welcomeGift": "Welcome gift",
    "voucher.offFirst": "off first pickup",
    "voucher.dialog.title": "$10 Voucher",
    "voucher.dialog.desc":
      "For all new customers on their first pickup booking. We'll email your code so it's saved for later, too.",
    "voucher.dialog.code": "Your voucher code",
    "voucher.dialog.mention":
      "Mention this code when you schedule your first pickup and we'll take $10 off your order. Single use per household.",
    "voucher.dialog.scheduleFirst": "Schedule my first pickup",
    "voucher.dialog.fullName": "Full name",
    "voucher.dialog.email": "Email",
    "voucher.dialog.phone": "Phone",
    "voucher.dialog.optional": "(optional)",
    "voucher.dialog.disclaimer":
      "One voucher per email. Valid on your first pickup booking.",

    "how.tag": "How it works",
    "how.title": "Three easy steps. Zero hassle.",
    "how.body":
      "From the first click to fresh, folded laundry on your doorstep — our pickup & delivery is designed around your schedule.",
    "how.s1.title": "Schedule a pickup",
    "how.s1.body":
      "Book online in under a minute. Choose any pickup day and a time window that works for you.",
    "how.s2.title": "We pick up — free",
    "how.s2.body":
      "Leave your bag at your doorstep. Our team grabs it, no contact required.",
    "how.s3.title": "We deliver clean",
    "how.s3.body":
      "Expertly cleaned, pressed and wrapped — back at your door in 48 hours or less.",

    "meet.tag": "Meet the family",
    "meet.title1": "From our family,",
    "meet.title2": "to yours.",
    "meet.body1":
      "Oxford Cleaners is run by our family — right here in Chandler. Every garment is handled by people you'll actually meet, who live in the same neighborhoods you do.",
    "meet.body2":
      "When you book a pickup, you're supporting a small, family-owned business that's been part of the East Valley community for years.",
    "meet.imageCaption": "The Oxford Cleaners family — Chandler, AZ",

    "family.tag": "Family-first",
    "family.title1": "We treat your clothes like",
    "family.title2": "our own kids' clothes.",
    "family.body1":
      "Oxford Cleaners has been a small, family-run shop from day one. Most of our customers are families like ours — chasing kids, running carpools, and trying to keep the soccer uniform actually clean.",
    "family.body2":
      "That's why our service is built to give parents one less thing to worry about: free pickup at your door, friendly faces, and clothes that come back looking like new.",
    "family.stat1": "Generations of garment care",
    "family.stat2": "Happy local families",
    "family.stat3": "Average turnaround",
    "family.quote":
      "\"Feels like dropping clothes off with family. They remember our kids' names — and our soccer-jersey stains.\"",
    "family.quoteAuthor": "— The Hernandez family, Chandler",

    "coverage.tag": "Service area",
    "coverage.title": "Door-to-door across the East Valley.",
    "coverage.body":
      "We offer free pickup and delivery across five cities with a $25 order minimum — no extra fees. Not sure if we cover your block? Just give us a call.",
    "coverage.cityNote": "ZIP codes served",
    "coverage.checkArea": "Call to confirm your address",

    "faq.tag": "Questions?",
    "faq.title": "Frequently asked questions.",
    "faq.subtitle":
      "Can't find your answer? Give us a call at 480-940-6023 — we're happy to help.",

    "footer.servicesHeading": "Services",
    "footer.contactHeading": "Get in touch",
    "footer.serving": "Serving",
    "footer.rights": "All rights reserved.",
    "footer.proudly": "Proudly Veteran-Owned",
    "footer.about":
      "Veteran & Family-Owned dry cleaning, laundry and alterations in Chandler, AZ — with free pickup & delivery across the East Valley.",

    "vet.eyebrow": "Our promise to those who served",
    "vet.title1": "US Flags & Class A uniforms,",
    "vet.title2": "cleaned free.",
    "vet.body":
      "Our owner is a proud U.S. Army Reserves veteran with 10 years of service. As our way of giving back to the incredible men and women who have served our country, we professionally clean every US flag and every military Class A uniform — completely free of charge.",
    "vet.benefit1.title": "US Flag — cleaned free",
    "vet.benefit1.body":
      "We professionally clean any retired or in-service US flag. Drop off in store or schedule a pickup.",
    "vet.benefit2.title": "Class A uniform — cleaned free",
    "vet.benefit2.body":
      "Full Class A service uniform cleaned, pressed and ready for inspection.",
    "vet.fineprint": "One free flag and one free Class A uniform per customer. No purchase necessary.",
    "vet.cta.schedule": "Schedule a free pickup",
    "vet.cta.visit": "Visit our Chandler store",
    "vet.badge": "Veteran-Owned · Family-Run",
    "vet.owner.caption": "Proud U.S. Army Reserves veteran — 10 years of service.",
    "vet.owner.alt": "Photograph of the Oxford Cleaners owner, a U.S. Army Reserves veteran.",
    "vet.claim.heading": "Claim your free wash",
    "vet.claim.desc": "Tell us what you'd like cleaned and we'll reach out to schedule a quick pickup or drop-off.",
    "vet.claim.item": "What would you like cleaned?",
    "vet.claim.item.flag": "US Flag",
    "vet.claim.item.uniform": "Class A Uniform",
    "vet.claim.name": "Full name",
    "vet.claim.email": "Email",
    "vet.claim.phone": "Phone (optional)",
    "vet.claim.submit": "Claim my free wash",
    "vet.claim.submitting": "Sending…",
    "vet.claim.success.title": "Thank you for your service.",
    "vet.claim.success.body":
      "Your free wash request is in. We'll reach out within one business day to set up your pickup or drop-off.",
    "vet.claim.success.another": "Submit another",
    "vet.claim.error": "Something went wrong. Please call us at 480-940-6023.",

    "heroes.cardTag": "Active Duty & First Responders",
    "heroes.cardTitle": "15% off every order, on us.",
    "heroes.cardBody":
      "A small thank-you for those still on the front lines. Claim your code in seconds.",
    "heroes.cardCta": "Get my 15% off code",
    "heroes.dialog.tag": "Heroes program",
    "heroes.dialog.title": "15% off — Heroes",
    "heroes.dialog.desc":
      "For Active Duty service members and First Responders. Show your ID at drop-off to redeem.",
    "heroes.dialog.role": "Who are you?",
    "heroes.dialog.role.active_duty": "Active Duty Military",
    "heroes.dialog.role.first_responder": "First Responder",
    "heroes.dialog.fullName": "Full name",
    "heroes.dialog.email": "Email",
    "heroes.dialog.phone": "Phone",
    "heroes.dialog.optional": "(optional)",
    "heroes.dialog.code": "Your discount code",
    "heroes.dialog.mention":
      "Mention this code at drop-off or pickup with a valid Active Duty / First Responder ID. One code per email.",
    "heroes.dialog.submit": "Get my 15% off code",
    "heroes.dialog.submitting": "Sending…",
    "heroes.dialog.scheduleFirst": "Schedule a pickup",
    "heroes.dialog.disclaimer":
      "One code per email. Valid with a current Active Duty or First Responder ID at drop-off or pickup.",
  },

  es: {
    "nav.services": "Servicios",
    "nav.howItWorks": "Cómo Funciona",
    "nav.schedule": "Reservar",
    "nav.reviews": "Reseñas",
    "nav.location": "Ubicación",
    "nav.faq": "Preguntas",
    "nav.blog": "Blog",
    "cta.schedulePickup": "Reservar Recogida",
    "cta.schedulePickupFree": "Reservar Recogida Gratis",
    "cta.tenOff": "$10 dto.",
    "cta.payOnline": "Pagar en Línea",
    "cta.claimTenVoucher": "Reclamar mi cupón de $10",
    "cta.exploreServices": "Ver Servicios",
    "cta.howItWorks": "Cómo funciona",
    "cta.call": "Llamar",
    "cta.scheduleShort": "Reservar",

    "hero.badge": "Orgullosamente Veterano y Familiar",
    "hero.title1": "La tintorería y lavandería",
    "hero.title2": "más querida del East Valley,",
    "hero.title3": "entregada con cariño.",
    "hero.subtitle":
      "Confiables en la misma ubicación de Chandler desde 1993 — más de 30 años de cuidado experto, ahora bajo nueva administración. Recogemos, limpiamos, planchamos y entregamos — gratis en todo el East Valley.",
    "hero.rating": "4.9 / 5",
    "hero.reviewsCount": "· 480+ reseñas locales",
    "hero.freePickup": "Recogida y entrega gratis",
    "hero.eco": "Limpieza ecológica",
    "hero.nowServing": "Ahora atendiendo",
    "hero.eastValley": "East Valley",
    "hero.nextPickup": "Próxima recogida disponible",
    "hero.nextPickupTime": "Mañana · 8:00 AM – 11:00 AM",
    "hero.reserveSpot": "Reservar Mi Lugar",

    "voucher.tag": "Bienvenida para nuevos clientes",
    "voucher.title1": "Obtén",
    "voucher.title2": "$10 de descuento",
    "voucher.title3": "en tu primera recogida.",
    "voucher.body":
      "Nos encantaría darte la bienvenida a la familia Oxford. Reclama tu cupón de $10 en segundos — muestra tu código en tu primera recogida y te lo descontamos. Sin trucos, sin mínimos.",
    "voucher.instantCode": "Código instantáneo",
    "voucher.noCard": "Sin tarjeta de crédito",
    "voucher.firstTime": "Clientes nuevos",
    "voucher.welcomeGift": "Regalo de bienvenida",
    "voucher.offFirst": "en tu primera recogida",
    "voucher.dialog.title": "Cupón de $10",
    "voucher.dialog.desc":
      "Para todos los clientes nuevos en su primera recogida. Te enviaremos el código por correo para guardarlo.",
    "voucher.dialog.code": "Tu código de cupón",
    "voucher.dialog.mention":
      "Menciona este código al reservar tu primera recogida y te descontaremos $10. Un uso por hogar.",
    "voucher.dialog.scheduleFirst": "Reservar mi primera recogida",
    "voucher.dialog.fullName": "Nombre completo",
    "voucher.dialog.email": "Correo electrónico",
    "voucher.dialog.phone": "Teléfono",
    "voucher.dialog.optional": "(opcional)",
    "voucher.dialog.disclaimer":
      "Un cupón por correo. Válido en tu primera recogida.",

    "how.tag": "Cómo funciona",
    "how.title": "Tres pasos fáciles. Cero complicaciones.",
    "how.body":
      "Desde el primer clic hasta ropa limpia y doblada en tu puerta — nuestra recogida y entrega está diseñada para tu horario.",
    "how.s1.title": "Reserva una recogida",
    "how.s1.body":
      "Reserva en línea en menos de un minuto. Elige el día y la ventana de tiempo que prefieras.",
    "how.s2.title": "Recogemos — gratis",
    "how.s2.body":
      "Deja tu bolsa en la puerta. Nuestro equipo la recoge, sin contacto necesario.",
    "how.s3.title": "Entregamos limpio",
    "how.s3.body":
      "Limpiado, planchado y envuelto con cuidado — de vuelta a tu puerta en 48 horas o menos.",

    "meet.tag": "Conoce la familia",
    "meet.title1": "De nuestra familia,",
    "meet.title2": "a la tuya.",
    "meet.body1":
      "Oxford Cleaners es manejado por una familia — aquí mismo en Chandler. Cada prenda es atendida por personas que conocerás en persona, que viven en los mismos vecindarios que tú.",
    "meet.body2":
      "Cuando reservas una recogida, estás apoyando a un pequeño negocio familiar que ha sido parte de la comunidad del East Valley durante años.",
    "meet.imageCaption": "La familia Oxford Cleaners — Chandler, AZ",

    "family.tag": "La familia primero",
    "family.title1": "Tratamos tu ropa como",
    "family.title2": "la ropa de nuestros hijos.",
    "family.body1":
      "Oxford Cleaners ha sido una pequeña tienda familiar desde el primer día. La mayoría de nuestros clientes son familias como la nuestra — corriendo tras los niños, manejando carpools, e intentando mantener limpio el uniforme de fútbol.",
    "family.body2":
      "Por eso nuestro servicio está hecho para darles a los padres una cosa menos de qué preocuparse: recogida gratis en tu puerta, caras amables y ropa que vuelve como nueva.",
    "family.stat1": "Generaciones de cuidado de ropa",
    "family.stat2": "Familias locales felices",
    "family.stat3": "Tiempo promedio",
    "family.quote":
      "\"Es como dejar la ropa en familia. Recuerdan los nombres de nuestros hijos — y las manchas de los uniformes de fútbol.\"",
    "family.quoteAuthor": "— La familia Hernandez, Chandler",

    "coverage.tag": "Área de servicio",
    "coverage.title": "De puerta a puerta en todo el East Valley.",
    "coverage.body":
      "Ofrecemos recogida y entrega gratis en cinco ciudades con un mínimo de pedido de $25 — sin cargos extra. ¿No estás seguro si cubrimos tu zona? Solo llámanos.",
    "coverage.cityNote": "Códigos postales atendidos",
    "coverage.checkArea": "Llama para confirmar tu dirección",

    "faq.tag": "¿Preguntas?",
    "faq.title": "Preguntas frecuentes.",
    "faq.subtitle":
      "¿No encuentras tu respuesta? Llámanos al 480-940-6023 — con gusto te ayudamos.",

    "footer.servicesHeading": "Servicios",
    "footer.contactHeading": "Contacto",
    "footer.serving": "Atendiendo",
    "footer.rights": "Todos los derechos reservados.",
    "footer.proudly": "Orgullosamente Veterano",
    "footer.about":
      "Tintorería, lavandería y arreglos veterano y familiar en Chandler, AZ — con recogida y entrega gratis en todo el East Valley.",

    "vet.eyebrow": "Nuestra promesa a quienes sirvieron",
    "vet.title1": "Banderas de EE.UU. y uniformes Clase A,",
    "vet.title2": "limpiados gratis.",
    "vet.body":
      "Nuestro dueño es un orgulloso veterano de la Reserva del Ejército de EE.UU. con 10 años de servicio. Como muestra de gratitud hacia los hombres y mujeres que han servido a nuestro país, lavamos y planchamos profesionalmente cada bandera de EE.UU. y cada uniforme militar Clase A — completamente gratis.",
    "vet.benefit1.title": "Bandera de EE.UU. — gratis",
    "vet.benefit1.body":
      "Limpiamos profesionalmente cualquier bandera de EE.UU., retirada o en servicio. Déjala en la tienda o reserva una recogida.",
    "vet.benefit2.title": "Uniforme Clase A — gratis",
    "vet.benefit2.body":
      "Uniforme Clase A completo limpiado, planchado y listo para inspección.",
    "vet.fineprint": "Una bandera y un uniforme Clase A gratis por cliente. Sin compra necesaria.",
    "vet.cta.schedule": "Reservar recogida gratis",
    "vet.cta.visit": "Visitar nuestra tienda en Chandler",
    "vet.badge": "Veterano · Familiar",
    "vet.owner.caption": "Orgulloso veterano de la Reserva del Ejército de EE.UU. — 10 años de servicio.",
    "vet.owner.alt": "Fotografía del dueño de Oxford Cleaners, veterano de la Reserva del Ejército de EE.UU.",
    "vet.claim.heading": "Reclama tu lavado gratis",
    "vet.claim.desc": "Cuéntanos qué te gustaría limpiar y te contactaremos para coordinar una recogida o entrega.",
    "vet.claim.item": "¿Qué te gustaría limpiar?",
    "vet.claim.item.flag": "Bandera de EE.UU.",
    "vet.claim.item.uniform": "Uniforme Clase A",
    "vet.claim.name": "Nombre completo",
    "vet.claim.email": "Correo electrónico",
    "vet.claim.phone": "Teléfono (opcional)",
    "vet.claim.submit": "Reclamar mi lavado gratis",
    "vet.claim.submitting": "Enviando…",
    "vet.claim.success.title": "Gracias por tu servicio.",
    "vet.claim.success.body":
      "Tu solicitud de lavado gratis fue recibida. Te contactaremos dentro de un día hábil para coordinar la recogida o entrega.",
    "vet.claim.success.another": "Enviar otra",
    "vet.claim.error": "Algo salió mal. Llámanos al 480-940-6023.",

    "heroes.cardTag": "Servicio Activo y Socorristas",
    "heroes.cardTitle": "15% de descuento en cada pedido.",
    "heroes.cardBody":
      "Un pequeño agradecimiento para quienes siguen en la primera línea. Reclama tu código en segundos.",
    "heroes.cardCta": "Obtener mi código de 15%",
    "heroes.dialog.tag": "Programa Héroes",
    "heroes.dialog.title": "15% de descuento — Héroes",
    "heroes.dialog.desc":
      "Para militares en servicio activo y socorristas. Muestra tu identificación al entregar la ropa para canjear.",
    "heroes.dialog.role": "¿Quién eres?",
    "heroes.dialog.role.active_duty": "Militar en Servicio Activo",
    "heroes.dialog.role.first_responder": "Socorrista",
    "heroes.dialog.fullName": "Nombre completo",
    "heroes.dialog.email": "Correo electrónico",
    "heroes.dialog.phone": "Teléfono",
    "heroes.dialog.optional": "(opcional)",
    "heroes.dialog.code": "Tu código de descuento",
    "heroes.dialog.mention":
      "Menciona este código al entregar o recoger con una identificación válida de Servicio Activo / Socorrista. Un código por correo.",
    "heroes.dialog.submit": "Obtener mi código de 15%",
    "heroes.dialog.submitting": "Enviando…",
    "heroes.dialog.scheduleFirst": "Reservar una recogida",
    "heroes.dialog.disclaimer":
      "Un código por correo. Válido con una identificación vigente de Servicio Activo o Socorrista al entregar o recoger.",
  },
};

const I18nContext = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("oxford_lang") || "en";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("oxford_lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const setLang = (l) => setLangState(l);
  const t = (key) => {
    const table = STRINGS[lang] || STRINGS.en;
    return table[key] ?? STRINGS.en[key] ?? key;
  };

  const value = useMemo(() => ({ lang, t, setLang }), [lang]);

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
}

export const useT = () => useContext(I18nContext);
